import {
    CanvasTexture,
    NearestFilter,
    ClampToEdgeWrapping,
    RepeatWrapping,
} from "three";
import {
    HEATMAP_LAT_SPACING,
    HEATMAP_LNG_SPACING,
    HEATMAP_DECAY_RATE,
    HEATMAP_PAINT_STRENGTH,
} from "./config";

export default class GlobeHeatMap {
    constructor(
        latSpacing = HEATMAP_LAT_SPACING,
        lngSpacing = HEATMAP_LNG_SPACING,
        decayRate = HEATMAP_DECAY_RATE,
        paintStrength = HEATMAP_PAINT_STRENGTH,
    ) {
        this._cols = Math.ceil(360 / lngSpacing);
        this._rows = Math.ceil(180 / latSpacing);
        this._decayRate = decayRate;
        this._paintStrength = paintStrength;

        this._heat = new Float32Array(this._cols * this._rows);

        this._canvas = document.createElement("canvas");
        this._canvas.width = this._cols;
        this._canvas.height = this._rows;
        this._ctx = this._canvas.getContext("2d");

        this.texture = new CanvasTexture(this._canvas);
        this.texture.minFilter = NearestFilter;
        this.texture.magFilter = NearestFilter;
        this.texture.wrapS = RepeatWrapping;
        this.texture.wrapT = ClampToEdgeWrapping;
        this.texture.flipY = false;

        this._imageData = this._ctx.createImageData(this._cols, this._rows);
    }

    update(mouseUV) {
        const { _heat, _cols, _rows, _decayRate, _paintStrength, _imageData } =
            this;

        for (let i = 0; i < _heat.length; i++) {
            _heat[i] *= _decayRate;
            if (_heat[i] < 0.001) _heat[i] = 0;
        }

        if (mouseUV && mouseUV.x >= 0) {
            const col = Math.floor(mouseUV.x * _cols) % _cols;

            let row = Math.floor(mouseUV.y * _rows);
            row = Math.max(0, Math.min(_rows - 1, row));

            const idx = row * _cols + col;
            _heat[idx] = Math.min(1.0, _heat[idx] + _paintStrength);
        }

        const data = _imageData.data;
        for (let i = 0; i < _heat.length; i++) {
            const v = (_heat[i] * 255) | 0;
            const p = i * 4;
            data[p] = v;
            data[p + 3] = 255;
        }

        this._ctx.putImageData(_imageData, 0, 0);
        this.texture.needsUpdate = true;
    }

    dispose() {
        this.texture.dispose();
    }
}
